import Text from './Text.vue';

export default Text;
